module.exports = __webpack_public_path__ + "img/echars1.5d13945c.png";